import React from 'react'
import styled from 'styled-components'
import PlayIcon from '../../../Icons/Play/Play'
import { White } from '../../../../Constants/ColorChart'
import FeatherIconWrapper from "../../../Icons/FeatherIconWrapper";

/*
 *  @Description:   Stateless component that represents the playlist Icon. Used to show in a Playlist header.
 */

const StyledIcon = styled.div`
    border-radius: 9px 9px;
    margin-left: auto;
    margin-right: auto;
    border: 1px solid ${ White };
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: 992px){
        border: 2px solid ${ White };
        width: 240px;
        height: 240px;
    }
    @media screen and (min-width: 1200px){
        border: 3px solid ${ White };
        width: 260px;
        height: 260px;
    }
    @media screen and (min-width: 1600px){
        border: 4px solid ${ White };
        width: 280px;
        height: 280px;
    }
    @media screen and (min-width: 1800px){
        border: 5px solid ${ White };
        width: 300px;
        height: 300px;
    }
    .PlaylistIcon{
         height: 35px!important; width: 40px!important;
    
        @media (min-width: 768px) {
             height: 55px!important; width: 55px!important;
        }
        
        @media (min-width: 992px) {
             height: 60px!important; width: 60px!important;
        }
        
        @media (min-width: 1200px) {
             height: 65px!important;width: 65px!important;
        }
        
        @media (min-width: 1600px) {
             height: 70px!important; width: 70px!important;
        }
        @media (min-width: 1800px) {
             height: 75px!important; width: 75px!important;
        }
    }
    
`;

const PlaylistIcon = () => {

    return (
        <StyledIcon>
            <FeatherIconWrapper
                color={ White }
                className={"PlaylistIcon"}
                width={ "35px" }
                Icon={ PlayIcon }
            />
        </StyledIcon>

    );

}


export default PlaylistIcon;